import { MilestoneTypes } from './actionTypes';

const INIT_STATE = {
    dataList: [],
    dataListOperation: [],
    clientsDetail: {},
    clientsAdd: {},
    deleteId: undefined,
    clientsUpdate: {},
    error: {},
    success: '',
    isLoading: false,
    salesOrdersData: [],
    milestoneConfig: [],

    isLoadingLifeEvents: false,
    isLoadingLifeEventsAdd: false,
    MilestonesLifeEvents: []
};

const Milestones = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case MilestoneTypes.GET_MILESTONES:
            state = { ...state, isLoading: true };
            break;
        case MilestoneTypes.GET_MILESTONES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                dataList: action.payload,
            };
        case MilestoneTypes.GET_MILESTONES_FAIL:
            return {
                ...state,
                error: action.payload,
                dataList: [],
            };
        case MilestoneTypes.GET_MILESTONES_DETAIL_SUCCESS:
            return {
                ...state,
                clientsDetail: action.payload,
            };
        case MilestoneTypes.GET_MILESTONES_DETAIL_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        case MilestoneTypes.ADD_MILESTONES:
            state = { ...state };
            break;
        case MilestoneTypes.ADD_MILESTONES_SUCCESS:
            return {
                ...state,
                clientsAdd: action.payload,
            };
        case MilestoneTypes.ADD_MILESTONES_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        case MilestoneTypes.DELETE_MILESTONES:
            state = { ...state };
            break;
        case MilestoneTypes.DELETE_MILESTONES_SUCCESS:
            return {
                ...state,
                deleteId: action.payload,
            };
        case MilestoneTypes.DELETE_MILESTONES_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        case MilestoneTypes.UPDATE_MILESTONES:
            return {
                ...state,
            };
        case MilestoneTypes.UPDATE_MILESTONES_SUCCESS:
            return {
                ...state,
                clientsUpdate: action.payload,
            };
        case MilestoneTypes.UPDATE_MILESTONES_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case MilestoneTypes.GET_MILESTONES_OPERATION_DATA:
            state = {
                ...state,
                isLoading: true,
                dataListOperation: [],
                milestoneConfig: [],
            };
            break;
        case MilestoneTypes.GET_MILESTONES_OPERATION_DATA_SUCCESS:
            return {
                ...state,
                dataListOperation: action.payload.data.length > 0 ? action.payload.data[0] : {},
                milestoneConfig: action.payload.milestoneConfig,
                isLoading: false,
            };
        case MilestoneTypes.GET_MILESTONES_OPERATION_DATA_FAIL:
            return {
                ...state,
                error: action.payload,
                dataListOperation: [],
            };

        case MilestoneTypes.GET_MILESTONES_LIFE_EVENTS_DATA:
            state = {
                ...state,
                isLoadingLifeEvents: true,
                MilestonesLifeEvents: []
            };
            break;
        case MilestoneTypes.GET_MILESTONES_LIFE_EVENTS_DATA_SUCCESS:
            return {
                ...state,
                MilestonesLifeEvents: action.payload ?? [],
                isLoadingLifeEvents: false,
            };
        case MilestoneTypes.GET_MILESTONES_LIFE_EVENTS_DATA_FAIL:
            return {
                ...state,
                error: action.payload,
                MilestonesLifeEvents: [],
            };

        case MilestoneTypes.ADD_MILESTONES_LIFE_EVENTS:
            state = {
                ...state,
                success:"",
                isLoadingLifeEventsAdd: true
            };
            break;
        case MilestoneTypes.ADD_MILESTONES_LIFE_EVENTS_SUCCESS:
            return {
                ...state,
                isLoadingLifeEventsAdd: false,
                success: action.payload
            };
        case MilestoneTypes.ADD_MILESTONES_LIFE_EVENTS_FAIL:
            return {
                ...state,
                isLoadingLifeEventsAdd: false,
                error: action.payload
            };

        default:
            break;
    }
    return state;
};

export default Milestones;
